import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const FilterList = ({ parentEntity, parentEntityObj }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!parentEntity) return;
      rowsReq.expr = ExprUtils.whereParams('entity', parentEntity, 'entityId', parentEntityObj.id);
    },
    [parentEntity, parentEntityObj],
  );

  return <EntityList entity="FILTER" augRowsReq={augRowsReq} />;
};
